module.exports = __webpack_public_path__ + "static/media/wind.ac2b82a4.svg";